var exports = {
  "Qs": "GiftAcceptModal.module__content___MkpTa3",
  "O8": "GiftAcceptModal.module__loadingContent___MkpTa3",
  "Nr": "GiftAcceptModal.module__card___MkpTa3",
  "$2": "GiftAcceptModal.module__cardGrid___MkpTa3",
  "kJ": "GiftAcceptModal.module__iconCircle___MkpTa3",
  "SP": "GiftAcceptModal.module__iconCircleActive___MkpTa3",
  "PP": "GiftAcceptModal.module__iconCircleInactive___MkpTa3",
  "_O": "GiftAcceptModal.module__iconCircleDisabled___MkpTa3",
  "Kk": "GiftAcceptModal.module__icon___MkpTa3",
  "m5": "GiftAcceptModal.module__iconError___MkpTa3",
  "Ux": "GiftAcceptModal.module__cardContent___MkpTa3",
  "DD": "GiftAcceptModal.module__title___MkpTa3",
  "jn": "GiftAcceptModal.module__titlePrimary___MkpTa3",
  "xP": "GiftAcceptModal.module__titleTertiary___MkpTa3",
  "S3": "GiftAcceptModal.module__titleDanger___MkpTa3",
  "VA": "GiftAcceptModal.module__subtitle___MkpTa3",
  "BK": "GiftAcceptModal.module__helpText___MkpTa3",
  "qr": "GiftAcceptModal.module__footer___MkpTa3",
};

module.exports = exports;
